import Translation from '../../services/translation/Translation';
import addTranslation from './addTranslation';
import ValidationContext from '../../components/form/_ValidationContext';

type Translations = Record<string, string>;
type AddValidationMessageArgs = [string, string, Translations] | [string, Translations];

const addValidationMessage = (...args: AddValidationMessageArgs) => {
  const [namespace, type, translations] = (args.length === 2) ? ['App', ...args] : args;

  Object.keys(translations).forEach((language) => {
    const message = translations[language];
    addTranslation(language, namespace, { [type]: message });
  });

  const validationMessageId = ValidationContext.getNewValidationMessageId();
  ValidationContext.registerMessage(validationMessageId, type, (value, options) => (
    Translation.t(`${namespace}:${type}`, { value, ...options })
  ));
};

export default addValidationMessage;
